import React, { useState, useRef, useEffect } from "react";
import "./AddAgreementModal.css";
import PrimaryButton from "../PrimaryButton/PrimaryButton";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { useDispatch } from "react-redux";
import { createAgreement } from "../../store/usersSlice";
import toast from "react-hot-toast";

const AddAgreementModal = ({ isOpen, onClose, onSuccess }) => {
  const modalRef = useRef(null);
  const [titleValue, setTitleValue] = useState("");
  const [descriptionValue, setDescriptionValue] = useState("");
  const [codeValue, setCodeValue] = useState("PRIVACY_POLICY");
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  const modalStyles = {
    input: {
      width: "400px",
      padding: "16px",
      paddingTop: "7px",
      fontFamily: "NT Somic",
      backgroundColor: "transparent",
      border: "1px solid #333b4b",
      borderRadius: "8px",
      color: "#717b8e",
      fontSize: "14px",
      fontWeight: 500,
      marginBottom: "8px",
      resize: "none",
      height: "36px",
      minHeight: "36px",
      maxHeight: "36px",
      lineHeight: "1.5",
      boxSizing: "border-box",
      overflowY: "auto",
    },
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  if (!isOpen) return null;

  const handleCreateAgreement = () => {
    if (isLoading) return;
    setIsLoading(true);
    const formData = {
      code: codeValue,
      name: titleValue,
      description: descriptionValue,
    };

    dispatch(createAgreement(formData)).then((res) => {
      if (!res.error) {
        setIsLoading(false);
        onSuccess();
        toast.success("Документ создан!");
      } else {
        toast.error(res.payload);
        setIsLoading(false);
      }
    });
  };

  return (
    <div className="add-agreement-modal-overlay">
      <div className="add-agreement-modal" ref={modalRef}>
        <button className="release-notes-close-button" onClick={onClose} />
        <h1 className="add-agreement-title">Добавить новый документ</h1>
        <textarea
          readOnly={false}
          value={titleValue}
          style={{
            ...modalStyles.input,
            lineHeight: "20px",
            display: "-webkit-box",
            WebkitLineClamp: "2",
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            "::placeholder": {
              color: "#4a4f5c",
            },
          }}
          placeholder={"Название"}
          onChange={(e) => setTitleValue(e.target.value)}
        />
        <textarea
          readOnly={false}
          value={descriptionValue}
          style={{
            ...modalStyles.input,
            lineHeight: "20px",
            display: "-webkit-box",
            WebkitLineClamp: "2",
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            "::placeholder": {
              color: "#4a4f5c",
            },
          }}
          placeholder={"Описание"}
          onChange={(e) => setDescriptionValue(e.target.value)}
        />
        <select
          value={codeValue}
          onChange={(e) => setCodeValue(e.target.value)}
          style={{
            backgroundColor: "transparent",
            border: "none",
            color: "#717b8e",
            fontSize: "14px",
            fontFamily: "NT Somic",
            fontWeight: 500,
            cursor: "pointer",
            // appearance: "none",
            textAlign: "right",
            paddingRight: "12px",
            marginTop: 10,
            width: "100%",
            WebkitTapHighlightColor: "transparent",
            WebkitTouchCallout: "none",
            WebkitUserSelect: "none",
            MozUserSelect: "none",
            msUserSelect: "none",
            userSelect: "none",
            outline: "none",
          }}
        >
          <option key={"PRIVACY_POLICY"} value={"PRIVACY_POLICY"}>
            Политика конфиденциальности
          </option>
          <option key={"LICENSE_AGREEMENT"} value={"LICENSE_AGREEMENT"}>
            Лицензионное соглашение
          </option>
          <option key={"TERMS_OF_SERVICE"} value={"TERMS_OF_SERVICE"}>
            Правила пользования
          </option>
        </select>
        <PrimaryButton
          text={"Добавить"}
          onClick={() => handleCreateAgreement()}
          style={{ marginLeft: "8px", marginTop: 24, padding: "12px 24px" }}
        />
      </div>
    </div>
  );
};

export default AddAgreementModal;
